(() => {
  const markAllCategoriesLinks = (scope = document) => {
    if (window.location.pathname !== '/pages/shop-all-categories') return;

    scope.querySelectorAll('.skit-category-directory a[href]').forEach((link) => {
      try {
        const target = new URL(link.getAttribute('href'), window.location.origin);
        if (target.origin !== window.location.origin) return;
        target.searchParams.set('skit_from', 'all-categories');
        link.setAttribute('href', target.pathname + target.search + target.hash);
      } catch (e) {}
    });
  };

  const updateContextReturnLinks = (scope = document) => {
    const url = new URL(window.location.href);
    const fromAllCategories = url.searchParams.get('skit_from') === 'all-categories';

    let sameOriginReferrer = false;
    if (document.referrer) {
      try {
        sameOriginReferrer = new URL(document.referrer).origin === window.location.origin;
      } catch (e) {}
    }

    const showContextMenu = sameOriginReferrer || fromAllCategories;

    scope.querySelectorAll('[data-skit-context-return]').forEach((link) => {
      const label = link.querySelector('[data-skit-context-return-label]');

      if (fromAllCategories) {
        link.href = link.dataset.categoriesHref || '/pages/shop-all-categories';
        if (label) label.textContent = 'All Categories';
      } else {
        link.href = '/';
        if (label) label.textContent = 'Main Store';
      }
    });

    document.documentElement.classList.toggle('skit-context-menu-enabled', showContextMenu);
  };

  const init = (scope = document) => {
    markAllCategoriesLinks(scope);
    updateContextReturnLinks(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();